<template>
  <div>
    <Header id="homeHeader" />
    <main class="main">
      <!-- <SnowEffect /> -->
      <section class="container mt-2 mt-xl-5 mb-4">
        <div class="row h-100 align-items-stretch">
          <div class="col-12 col-xl-9">
            <HomeSlider />
          </div>
          <div class="col-12 col-xl-3 mt-5 mt-xl-0 benibox">
            <SingleAmazingProduct />
          </div>
        </div>
      </section>
      <!-- دسته بندی ها -->
      <div class="container">
        <ProductCategories />
      </div>
      <div class="container banner_one d-flex d-md-none">
        <ResponsiveBanner
          class="w-100"
          :item="access($store.getters, 'front/getAdvertisements.center')"
          :mobile-item="
            access($store.getters, 'front/getAdvertisements.center_mobile')
          "
        />
      </div>
      <!-- محصولات پیشنهادی اول -->
      <div class="container" v-if="recommendations">
        <template
          v-if="
            recommendations[1] &&
            recommendations[1].products &&
            recommendations[1].products.length
          "
        >
          <RecommendationSliders
            class="!mt-0 mt-md-auto"
            :data="recommendations[1]"
          />
        </template>
      </div>
      <div class="container" v-else>
        <swiperSkeleton></swiperSkeleton>
      </div>
      <!-- بنر تکی -->
      <div class="container banner_one d-none d-md-flex">
        <ResponsiveBanner
          class="w-100"
          :item="access($store.getters, 'front/getAdvertisements.center')"
          :mobile-item="
            access($store.getters, 'front/getAdvertisements.center_mobile')
          "
        />
      </div>
      <!-- بنر تقویم -->
      <div
        class="container"
        v-if="advertiseBanners && advertiseBanners.calendar_desk1"
      >
        <template v-if="advertiseBanners.calendar_desk1.picture">
          <div
            class="d-none d-md-flex align-items-center justify-content-between"
          >
            <HomeBanners :banner="advertiseBanners.calendar_desk1" />
            <HomeBanners :banner="advertiseBanners.calendar_desk2" />
          </div>
          <div
            class="d-flex d-md-none align-items-center justify-content-between flex-column mt-2"
          >
            <HomeBanners :banner="advertiseBanners.calendar_mobile1" />
            <HomeBanners
              :banner="advertiseBanners.calendar_mobile2"
              class="mt-4"
            />
          </div>
        </template>
        <div
          v-else
          class="d-flex w-100 align-items-center justify-content-between flex-column flex-md-row mt-2 mt-lg-5"
          style="gap: 1rem"
        >
          <Skeleton class="w-1/2" style="height: 150px"></Skeleton>
          <Skeleton class="w-1/2" style="height: 150px"></Skeleton>
        </div>
      </div>
      <!-- محصولات شگفت انگیز -->
      <RecommendedProductSlider class="mt-4 mt-lg-5" />

      <div>
        <QuadrupleBanner />
      </div>
      <!-- محصولات ویژه و پکیج ها -->

      <div class="container mt-2 mt-lg-5" v-if="recommendations">
        <template
          v-if="
            recommendations[5] &&
            recommendations[5].products &&
            recommendations[5].products.length
          "
        >
          <RecommendationSliders :data="recommendations[5]" />
        </template>
      </div>
      <div class="container mt-2 mt-lg-5" v-else>
        <swiperSkeleton></swiperSkeleton>
      </div>
      <!-- بنر تکی -->
      <banners
        class="container"
        v-if="advertiseBanners && advertiseBanners.single_bottomBanner"
        :banner="advertiseBanners.single_bottomBanner"
        fullWidth
      />

      <!-- محصولات ویژه و پکیج ها -->
      <!-- <SpecialProduct class="mt-5 mt-lg-5" /> -->
      <!-- محصولات پیشنهادی دوم -->
      <div class="container" v-if="recommendations">
        <template
          v-if="
            recommendations[2] &&
            recommendations[2].products &&
            recommendations[2].products.length
          "
        >
          <RecommendationSliders :data="recommendations[2]" />
        </template>
      </div>
      <div class="container" v-else>
        <swiperSkeleton></swiperSkeleton>
      </div>
      <div class="container">
        <!-- بنر تکی -->
        <HomeBanners
          v-if="advertiseBanners"
          :banner="advertiseBanners.single_banner_1"
          fullWidth
        />
        <Skeleton v-else style="height: 300px"></Skeleton>
      </div>
      <!-- تب محصولات بندیتو -->
      <!-- <ProductTab class="mt-4 mt-lg-5" /> -->
      <div class="container mt-2 mt-lg-5" v-if="recommendations">
        <template
          v-if="
            recommendations[6] &&
            recommendations[6].products &&
            recommendations[6].products.length
          "
        >
          <RecommendationSliders :data="recommendations[6]" />
        </template>
      </div>
      <div class="container mt-2 mt-lg-5" v-else>
        <swiperSkeleton></swiperSkeleton>
      </div>
      <!-- بنر های دوقلو -->
      <div class="container">
        <div
          v-if="advertiseBanners"
          class="d-flex align-items-center justify-content-between flex-column flex-md-row mt-2 mt-lg-5"
        >
          <HomeBanners :banner="advertiseBanners.bottom_right" />
          <HomeBanners
            :banner="advertiseBanners.bottom_left"
            class="mt-4 mt-md-0"
          />
        </div>
        <div
          v-else
          class="d-flex w-100 align-items-center justify-content-between flex-column flex-md-row mt-2 mt-lg-5"
          style="gap: 1rem"
        >
          <Skeleton class="w-1/2" style="height: 150px"></Skeleton>
          <Skeleton class="w-1/2" style="height: 150px"></Skeleton>
        </div>
        <!-- محصولات پیشنهادی سوم -->
      </div>
      <div class="container" v-if="recommendations">
        <template
          v-if="
            recommendations &&
            recommendations[3] &&
            recommendations[3].products &&
            recommendations[3].products.length
          "
        >
          <RecommendationSliders :data="recommendations[3]" />
        </template>
      </div>
      <div class="container" v-else>
        <swiperSkeleton></swiperSkeleton>
      </div>
      <!-- تصاویر قبل و بعد -->
      <div>
        <BeforeAfter />
      </div>
      <!-- بنر های دوقلو -->
      <div
        v-if="advertiseBanners"
        class="container d-flex align-items-center justify-content-between flex-column flex-md-row mt-2 mt-lg-5"
      >
        <HomeBanners :banner="advertiseBanners.twin_banner_4" />
        <HomeBanners
          :banner="advertiseBanners.twin_banner_5"
          class="mt-4 mt-md-0"
        />
      </div>
      <div
        v-else
        class="container d-flex w-100 align-items-center justify-content-between flex-column flex-md-row mt-2 mt-lg-5"
        style="gap: 1rem"
      >
        <Skeleton class="w-1/2" style="height: 250px"></Skeleton>
        <Skeleton class="w-1/2" style="height: 250px"></Skeleton>
      </div>
      <!-- مشتریان معتبر -->
      <div class="mt-5">
        <TrustedCustomers />
      </div>
      <div class="container mt-5">
        <!-- بنر تکی -->
        <HomeBanners
          v-if="advertiseBanners"
          :banner="advertiseBanners.single_banner_6"
          fullWidth
        />
        <Skeleton v-else style="height: 150px"></Skeleton>
      </div>
      <div class="container" v-if="recommendations">
        <!-- محصولات پیشنهادی چهارم -->
        <template
          v-if="
            recommendations[4] &&
            recommendations[4].products &&
            recommendations[4].products.length
          "
        >
          <RecommendationSliders :data="recommendations[4]" />
        </template>
      </div>
      <div class="container" v-else>
        <swiperSkeleton></swiperSkeleton>
      </div>
      <!-- کپین ها -->
      <Flashes v-if="Flashes" :flashes="Flashes" />
      <!-- وبلاگ ها -->
      <Weblogs class="mt-5" />
    </main>
  </div>
</template>
<script>
import SnowEffect from "../components/shared/SnowEffect .vue";
import QuadrupleBanner from "../components/home/QuadrupleBanner.vue";
import Header from "@/parts/Front/components/shared/Header";
import Flashes from "@/parts/Front/components/FlashProducts";
import Weblogs from "@/parts/Front/components/Weblogs";
import ProductTab from "@/parts/Front/components/home/productsTab.vue";
import SpecialProduct from "@/parts/Front/components/home/SpecialProduct.vue";
import RecommendedProductSlider from "@/parts/Front/components/RecommendedProductSlider";
import HomeSlider from "@/parts/Front/components/home/HomeSlider.vue";
import SingleAmazingProduct from "@/parts/Front/components/home/SingleAmazingProduct.vue";
import ResponsiveBanner from "@/parts/Front/components/ResponsiveBanner";
import TrustedCustomers from "@/parts/Front/components/about-us/Trusted-customers";
import Banners from "@/parts/Front/components/Banners";
import banners from "../components/banner.vue";
import HomeBanners from "@/parts/Front/components/HomeBanners.vue";
import ProductCategories from "@/parts/Front/components/ProductCategories.vue";
import BeforeAfter from "@/parts/Front/components/home/BeforeAfter.vue";
import categoryItem from "@/parts/Front/components/home/categoryItem.vue";
import RecommendationSliders from "@/parts/Front/components/shared/RecommendationSliders.vue";
export default {
  name: "Home",
  components: {
    banners,
    SnowEffect,
    QuadrupleBanner,
    RecommendedProductSlider,
    Header,
    Flashes,
    Weblogs,
    SpecialProduct,
    ProductTab,
    HomeSlider,
    SingleAmazingProduct,
    ResponsiveBanner,
    TrustedCustomers,
    Banners,
    HomeBanners,
    ProductCategories,
    BeforeAfter,
    categoryItem,
    RecommendationSliders,
  },
  mounted() {
    // let savedPosition = localStorage.getItem("lastHomePosition");
    // if (savedPosition) {
    //   setTimeout(() => {
    //     this.$nextTick(() => {
    //       window.scrollTo(0, parseInt(savedPosition, 10));
    //     });
    //   }, 500);
    //   window.addEventListener("scroll", this.setLastPosition);
    // } else {
    //   window.addEventListener("scroll", this.setLastPosition);
    // }
    if (this.$route.fullPath.includes("loginModalOpened")) {
      document.getElementById("loginButton").click();
    }
    if (!this.specialCategories) {
      this.$store.dispatch("front/getSpecialCategoriesFromServer");
    }
    if (this.$store.getters["front/getFlashes"] == null) {
      this.$store.dispatch("front/getFlashesDataFromServer");
    }
    if (this.$store.getters["front/getAdvertisements"] == null) {
      this.$store.dispatch("front/getAdvertisementsDataFromServer");
    }
  },
  computed: {
    Flashes() {
      return this.$store.getters["front/getFlashes"];
    },
    specialCategories() {
      return this.$store.getters["front/getSpecialCategories"];
    },
    banners() {
      if (this.$store.getters["front/getAdvertisements"] != null) {
        let advertise = this.$store.getters["front/getAdvertisements"];
        return [
          [advertise.center, advertise.position2],
          [advertise.position3, advertise.position4],
        ];
      } else {
        return [
          [null, null],
          [null, null],
        ];
      }
    },
    // customeBanners() {
    //   if (this.$store.getters["front/getHomeData"] != null) {
    //     let advertise = this.$store.getters["front/getAdvertisements"];
    //     return advertise;
    //   } else {
    //     return null;
    //   }
    // },
    advertiseBanners() {
      if (this.$store.getters["front/getAdvertisements"] != null) {
        return this.$store.getters["front/getAdvertisements"];
      } else {
        return {};
      }
    },
    recommendations() {
      if (
        this.$store.getters["front/getHomeData"] &&
        this.$store.getters["front/getHomeData"].recommendations
      ) {
        return this.$store.getters["front/getHomeData"].recommendations;
      } else {
        return null;
      }
    },
  },
  methods: {
    // setLastPosition() {
    //   localStorage.setItem("lastHomePosition", window.scrollY);
    // },
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.setLastPosition);
  },
};
</script>
<style>
.banner_one {
  margin-bottom: 0rem !important;
}

.mt-8 {
  margin-top: 4.5rem !important;
}

@media (max-width: 768px) {
  .benibox {
    padding: 8px;
    background-color: #ff294f;
  }

  #timedProduct {
    background-color: white !important;
    box-shadow: 0 0 5px white;
  }

  .benibox .text-white {
    color: var(--color-444) !important;
  }

  .benibox .discount-price {
    color: var(--color-999) !important;
  }

  .benibox .product-discount-tag {
    color: white !important;
  }
}

@media screen and (max-width: 600px) {
  .banner_one {
    margin-bottom: 0rem !important;
  }
}
</style>
